import { CommonSearchInput } from 'components/common/form/search';
import { compact, uniq } from 'lodash';
import { useMemo } from 'react';
import { useVideosStore } from 'stores/use-videos-store';

interface IProps {
  onChange?: () => void;
}

export const VideosFilterPitcher = (props: IProps) => {
  const filter = useVideosStore((s) => s.filter);
  const videos = useVideosStore((s) => s.videos);

  const options = useMemo(() => {
    return compact(uniq(videos.map((o) => o.PitcherFullName?.trim()))).map(
      (o) => ({
        label: o,
        value: o,
      })
    );
  }, [videos]);

  return (
    <CommonSearchInput
      id="video-pitcher"
      placeholder="common.pitcher"
      options={options}
      values={filter.pitcher}
      onChange={(v) => {
        useVideosStore.getState().mergeFilter({ pitcher: v });
        props.onChange?.();
      }}
      multiple
      optional
    />
  );
};
